import { gql } from "apollo-boost";

export const me = gql`
  {
    me {
      title
      permissions {
        resId
        optIds
      }
    }
  }
`;

export const unreadMsg = gql`
  {
    unreadMsg {
      feedback
      childUpdate
      idCheck
      fundPending
      orgPending
    }
  }
`;

export const meGql = { me, unreadMsg };
